export { ChildResourceForbiddenHandler } from './lib/components/child-resource-forbidden-handler'
export { ChildResourceForbiddenScreen } from './lib/components/child-resource-forbidden-screen'
export { useChildResourceForbidden } from './lib/hooks/use-child-resource-forbidden'
